import logo1 from '../assets/images/logo1.png'
import './index.css'
import { FaLocationDot } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { IoLogoTiktok } from "react-icons/io5";
import { FaXTwitter } from "react-icons/fa6";

export const ProjectBlock = ({x, y})=>{

    return(
        <div 
            className="blockcircle" 
            style={{
                left: x - 25, // Adjust for button width/2
                top: y - 25, // Adjust for button height/2
                }}
            >
            <img src={logo1} alt="project logo" id="project_img"/>
            <div className='describ_div'>
                <h3>UNFOLDIX</h3>
                <p>Web agency website.</p>
                <p>deployed: 22/01/2025</p>
            </div>
        </div>
    )
}


export const CenterBlock =()=>{

    const centerX = window.innerWidth / 2;
    const centerY = window.innerHeight / 2;

    return(
        <div 
            className='centerblock'
            style={{
                left: centerX - 125,
                top: centerY - 150, 
                }}
            >
            <img src={logo1} alt="profile_img" id="profile_img"/>
            <h3>Larrien Saam</h3>
            <p><FaLocationDot className="location_icon"/>Yaounde, Cameroon</p>
            <div className='social_div'>
                <FaLinkedin className="icons"/>
                <FaInstagram className="icons"/>
                <IoLogoTiktok className="icons"/>
                <FaXTwitter className="icons"/>
            </div>
        </div>
    )
}



export const ProjectItem=({name, image, desc, link})=>{



    return(
        <div 
            className='item_block' 
            onClick={()=>{window.open(link, '_blank');}}
        >
            <div className='inner_block'>
                <img src={image} alt='item img' className='item_img' />
                <h3>{name}</h3>
            </div>
            <p>{desc}</p>
        </div>
    )
}